// adminApi.js
import axios from 'axios';

export const ADMIN_API_BASE = process.env.REACT_APP_ADMIN_API_BASE || 'http://localhost:8080';

export const adminApi = axios.create({
  baseURL: ADMIN_API_BASE,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);
